export const dayAvailabilityList_style = {
  rootSx: {
    borderBottom: '2px dashed #DBDBDB',
    // pb:3
  },
};
